<!-- 3d模型 -->
<template>
  <div id="three">

  

    <div id="chooseFrame" style="position: absolute;left: 10px;top: 10px;background-color: aliceblue;padding:5px;font-weight: bolder;">

    <a-checkbox @change="onChange" :checked="checkFrame">
      {{$t('components.outline')}}
    </a-checkbox>

    <a-button type="primary" size="small" @click="reset" style="display:relative">
      {{$t('components.reset')}}
    </a-button>

    </div>

  </div>
 
</template>

<script>
import * as Three from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import {CSG} from "./three-csg.js"
import { min } from "moment";


var myCamera = null
var myScene = null
var container = null

var vector = new Three.Vector2();//三维坐标对象

var rayPoints = null


var raycaster = new Three.Raycaster();

var data_points= null
var data_index = null

var down_flag = false  //判断粮面是否处于下锥


export default {
  name: "",
  props: ["datas","height","kuan","lgz","szgd","sz","xz"],
  data() {
    return {
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      pointCloudGeometry:null,
      pointCloud:null,
      material:null,
      cPoints:null,
      //粮面高度(锥体上开始计算)
      grainHeight: 410,
      bottomHeight: 80,

      // 窗口尺寸变化
      screenWidth: null,
      timer: null,
      checkFrame:true,
      GLTFobjects:null,
      GLTFobjects0:null,
      myControl:null,
      
    };
  },
  methods: {

    onChange(e) {

      this.checkFrame = e.target.checked

      console.log(`checked = ${e.target.checked}`);

      this.GLTFobjects.visible = this.checkFrame;
      if(this.GLTFobjects0!=null){
        this.GLTFobjects0.visible = this.checkFrame;
      }
      
    },

    reset(){
      this.myControl.reset();
    },

    init() {
      // console.log("??",controls);
      container = document.getElementById("three");

      this.scene  =  new Three.Scene();
      //this.scene.position(200,200,200)
      var directionalLight = new Three.DirectionalLight(0xffffff, 5);
      directionalLight.name = "directionalLight";
      //directionalLight.position.set(0, 100, 0);
      this.scene.add(directionalLight);

      
      this.camera  =new Three.PerspectiveCamera(
        75, window.innerWidth / window.innerHeight,0.1, 1000);

     
        

        this.camera.position.set(0, 0, 50); // 设置相机位置
        this.camera.lookAt(0, 0, 0); 
      this.scene.add(this.camera);
      this.renderer = new Three.WebGLRenderer({
        antialias: false,
        logarithmicDepthBuffer: true,
      });
      var control = new OrbitControls(this.camera, this.renderer.domElement);

      
      // control.minDistance = 300;
      // control.maxDistance = 1000;

      control.update();

    

      this.renderer.setClearColor(0x999966);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.outputEncoding = Three.sRGBEncoding;
      this.renderer.physicallyCorrectLights = true;
      this.renderer.setSize(container.clientWidth, container.clientHeight);

      // let geometry = new Three.CylinderBufferGeometry(0.2, 0.2, 0.2);

      // let material = new Three.MeshNormalMaterial();

      // this.mesh = new Three.Mesh(geometry, material);
      // 防止重复渲染
      if (container.children.length > 0) {
        //container.removeChild(container.children[0]);
      }
      container.appendChild(this.renderer.domElement);
      // 加载场景模型
      this.initContent();

      this.myControl = control

    },






    // 加载场景模型
    initContent() {

      // 加载 glTF 格式的模型
     
      this.loadData(this.datas)
      
    },
    renderScene() {
      requestAnimationFrame(this.renderScene);


      this.renderer.render(this.scene, this.camera);
    },


    loadData(data){

      let that = this

      let max_y = -10000 //最高点初始化
     
      let loader = new GLTFLoader(); /*实例化加载器*/
      const geometry = new Three.BufferGeometry();

      const positions = [];
      const fillPositions = [];
      const colors = [];
      const fillColors = []
      let points;

      console.log("datas",this.datas)
      console.log("lgz",this.lgz)
      console.log("height",this.height)
      console.log("kuan",this.kuan)
      console.log("szgd",this.szgd)
      console.log("xz",this.xz)
      console.log("sz",this.sz)


      

      const color = new Three.Color();

     
     
			
        let arr02 = null
				
        let indexArr = []
				//let type = "平房仓"
				let type = "圆筒仓"

        for ( let i = 0; i < 1000; i ++ ) {
          const phi = Math.random() * 2 * Math.PI;
          const theta = Math.random() * Math.PI;
          const x = this.kuan/100 * Math.cos(phi) * Math.sin(theta);
          const y = this.lgz/1000;
          const  z = this.kuan/100 * Math.sin(phi) * Math.sin(theta);

          


          positions.push( x, y, z );
          indexArr.push(new Three.Vector3( x, y, z ))
          // colors
          color.setRGB( 255, 204, 0 );
          colors.push( color.r, color.g, color.b );
        }
      

      geometry.setAttribute( 'position', new Three.Float32BufferAttribute( positions, 3 ) );
      geometry.setAttribute( 'color', new Three.Float32BufferAttribute( colors, 3 ) );

			

				//

       

				const material = new Three.PointsMaterial( { size: 3, color:"#FF3300" } );

material.sizeAttenuation = false;


points = new Three.Points( geometry, material );
points.frustumCulled = false;
this.scene.add( points );

const axesHelper = new Three.AxesHelper(100)
//this.scene.add(axesHelper)


//points.position.set(-this.chang*0.5, -this.kuan, -this.chang*0.5)

//添加平面
// triangulate x, z
var indexDelaunay = Delaunator.from(
    indexArr.map(v => {
      return [v.x, v.z];
    })
);


var meshIndex = []; // delaunay index => three.js index
for (let i = 0; i < indexDelaunay.triangles.length; i++){

  meshIndex.push(indexDelaunay.triangles[i]);
}


var geom = new Three.BufferGeometry().setFromPoints(indexArr);
geom.setIndex(meshIndex); // add three.js index to the existing geometry
geom.computeVertexNormals();
var mesh0 = new Three.Mesh(
    geom, // re-use the existing geometry
    new Three.MeshBasicMaterial({ color: "#FF6600", wireframe: false,side:Three.DoubleSide })
);



this.scene.add(mesh0);



//添加立方体

//长、框、高、下锥

let w_height = this.height/100;
let w_width = this.kuan/100;
let w_length = this.kuan/100;
let w_shangzhui = this.szgd/100;

//this.scene.position.set(w_length, w_height*2, w_length)
var axes = new Three.AxesHelper(4000);
      // axes.position.x = w_length;
      // axes.position.y = w_height*2;
      // axes.position.z = w_length;
      //this.scene.add(axes);

     





//定义shaderMaterial

const sdMaterial = new Three.ShaderMaterial({
  vertexShader:`
    varying vec3 vNormal;
    varying vec3 vPosition;
    void main(){
      vec4 modelPosition = modelMatrix * vec4(position,1.0);
      vec4 viewPosition = viewMatrix * modelPosition;
      vec4 projectedPosition = projectionMatrix * viewPosition;
      gl_Position = projectedPosition;
      vec3 modelNormal = (modelMatrix * vec4(normal,0.0)).xyz;
      vNormal = modelNormal;
      vPosition = modelPosition.xyz;
    }
  `,

  fragmentShader:`
    varying vec3 vNormal;
    varying vec3 vPosition;
    void main(){
      //Frenel
      vec3 viewDirection = normalize(vPosition - cameraPosition);
      vec3 normal = normalize(vNormal);
      float fresnel = dot(viewDirection,normal)+1.0;
      fresnel = pow(fresnel,2.0);
      gl_FragColor = vec4(vec3(fresnel),1.0);
      
    }
  
  `,
  
})

//添加gltf



loader.load( '/hxc_model_single/cylinder_m.glb', function ( gltf ) {

  gltf.scene.scale.set(w_width,w_height/2,w_width)

      

that.scene.add( gltf.scene )
that.GLTFobjects = gltf.scene
//render();

} );



  if(this.xz == "有"){
    loader.load( '/hxc_model_single/cylinder_x.glb', function ( gltf ) {

              gltf.scene.traverse( function ( child ) {
								if ( child.isMesh ) {
									child.material = new Three.MeshBasicMaterial({color:"#FF6600"})
								}})

          gltf.scene.scale.set(w_width,w_height*0.05,w_width)
      
         that.scene.add( gltf.scene )

    } );
}

  if(this.sz == "有"){
    loader.load( '/hxc_model_single/cylinder_s.glb', function ( gltf ) {

          gltf.scene.scale.set(w_width,w_shangzhui,w_width)
          gltf.scene.position.set(0, w_height, 0)

          that.scene.add( gltf.scene )
          that.GLTFobjects0 = gltf.scene

    } );
  }


  const cGroup = new Three.Group()


  if(!this.isConsole){
  //布尔运算
var geometry111 = new Three.CylinderGeometry( w_length,  w_length,w_height*2,50,50,false );  // 盒子几何体
var material111 = new Three.MeshBasicMaterial( { color: 0xFF6600 } );  // 一种材料，设置集合体颜色
var cube111 = new Three.Mesh( geometry111, material111 );  // 网格，也就是几何体

//底部圆锥
var cone111 = new Three.Mesh(
        new Three.ConeGeometry(w_length,w_length,400),
        new Three.MeshBasicMaterial( { color: 0xFF6600,transparent:true,side:Three.DoubleSide } )
)
cone111.rotation.x = Math.PI

//this.scene.add(cube111)


cube111.position.set(0,w_height,0)


console.log(down_flag)
cone111.scale.set(0.98,1,0.98)
cube111.scale.set(0.98,1,0.98)

if(down_flag){

  
  mesh0.updateMatrix()
  cone111.updateMatrix()
  
  let bspA = new CSG.fromMesh( mesh0 )
  let bspB = new CSG.fromMesh( cone111 )
  let bspResult = bspA.intersect(bspB)
  let meshResult = CSG.toMesh( bspResult, bspB.matrix, bspB.material )
  meshResult.updateMatrix()
  meshResult.material = material111
  this.scene.add(meshResult)

  console.log('meshresult',meshResult)

}else{
  console.log(11111)
  //this.scene.add(cone111)
  
  mesh0.updateMatrix()
  cube111.updateMatrix()
  let bspA = new CSG.fromMesh( mesh0 )
  let bspB = new CSG.fromMesh( cube111 )
  let bspResult = bspA.intersect(bspB)
  let meshResult = CSG.toMesh( bspResult, bspB.matrix, bspB.material )
  meshResult.updateMatrix()
  meshResult.material = material111
  this.scene.add(meshResult)
  //meshResult.position.set(-w_length, 0, -w_length)
  
}

}
      

        

    },

  }, 
  computed: {},
  watch: {
    screenWidth() {
      if (!this.timer) {
        this.timer = true;
        setTimeout(() => {
          this.camera = null;
          this.scene = null;
          this.renderer = null;
          this.mesh = null;
          this.timer = false;
          this.init();
          this.renderScene();
        }, 1000);
      }
    },

    datas:{
      handler:function () {
                      if (typeof this.datas !== "undefined") {
                      this.init();
                      this.renderScene();
                    }
                },
      
    }
  },
  created() {},
  mounted() {

    

    if (typeof this.datas !== "undefined") {
      this.init();
      this.renderScene();
      
    }
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
};
</script>

<style lang="scss" scoped>
#three {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
